const PbxxRecord = require('../pbxx_record')

module.exports = class LandingPage extends PbxxRecord {
  static get class_name() {
    return 'LandingPage'
  }

  // TODO implement
  get preview_url() {
    return 'promoboxx.com'
  }

  add_widget(_opts) {
    return this._mapper().add_widget(this.id, _opts).then((response) => {
      return this
    }, (error) => {
      throw(error)
    })
  }

  reorder_widgets(_opts) {
    return this._mapper().reorder_widgets(this.id, _opts).then((response) => {
      return this
    }, (error) => {
      throw(error)
    })
  }

}
